import { UUID } from 'node:crypto';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { ProductionDataService } from '@shared/services/production-data.service';
import { ProductionTerminalService } from '@shared/services/production-terminal.service';
import { ITerminal, ITerminals, TerminalAdministrationService } from '@shared/services/terminalAdministration.service';

@Component({
	selector: 'app-terminal-select',
	templateUrl: './terminal-select.component.html',
	styleUrls: ['./terminal-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TerminalSelectComponent implements OnInit {
	#router: Router;
	#terminalAdministrationService: TerminalAdministrationService;
	#terminalProductionService: ProductionTerminalService;
	#dataService: ProductionDataService;
	public terminals: ITerminal[];
	public currentTerminalId: UUID | null;
	constructor(router: Router, terminalAdministrationService: TerminalAdministrationService, terminalProductionService: ProductionTerminalService, dataService: ProductionDataService) {
		this.#router = router;
		this.#terminalAdministrationService = terminalAdministrationService;
		this.#terminalProductionService = terminalProductionService;
		this.#dataService = dataService;
		this.terminals = [];
		this.currentTerminalId = null;
	}

	public ngOnInit(): void {
		this.#terminalAdministrationService.getTerminals().subscribe(this.#getTerminalsDone.bind(this));
	}

	#getTerminalsDone(terminals: ITerminals): void {
		this.terminals = terminals.result.sort(this.#terminalSort);
		this.#terminalProductionService.onTerminalIdChanged().subscribe(this.#terminalIdChanged.bind(this));
	}

	#terminalSort(a: ITerminal, b: ITerminal): -1 | 1 {
		return a.alias < b.alias ? -1 : 1;
	}

	#terminalIdChanged(id: UUID | null): void {
		this.currentTerminalId = id;
	}

	public terminalSelectionChange(event: MatSelectChange): void {
		void this.#updateURLWithTerminal(event.value);
	}

	async #updateURLWithTerminal(id: UUID | null): Promise<void> {
		if (id !== null) {
			await this.#router.navigateByUrl(`/mes/terminals/${id}`);
		}
	}
}
